import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Table,
  Overlay,
  Popover,
  Col,
  Form,
  Row,
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
ChartJS.register(ArcElement, Tooltip, Legend);

export const ADRRoomSoldMarketSegmentMixAnalysis = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const { snapshottitle, propertyCode, snapshotId } = useParams();

  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail
  );

  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate
  );

  const [tblids, settblids] = useState({
    id1: commonService.GenerateGUID(),
  });

  const widgetDetailRef = useRef();

  const [widgetModal, setWidgetModal] = useState(false);

  const closeWidgetModal = () => {
    setWidgetModal(false);
  };

  let dummydata = [
    {
      Date: "2025-06-01",
      MarketSegment: "RETAIL",
      "Rooms Sold": "0",
      "Average ADR": "0",
    },
    {
      Date: "2025-06-01",
      MarketSegment: "OTA DISCOUNT",
      "Rooms Sold": "0",
      "Average ADR": "0",
    },
    {
      Date: "2025-06-01",
      MarketSegment: "UNMAPPED",
      "Rooms Sold": "0",
      "Average ADR": "0",
    },
    {
      Date: "2025-06-01",
      MarketSegment: "BRAND DISCOUNT",
      "Rooms Sold": "0",
      "Average ADR": "0",
    },
    {
      Date: "2025-06-01",
      MarketSegment: "GROUP",
      "Rooms Sold": "0",
      "Average ADR": "0",
    },
    {
      Date: "2025-06-01",
      MarketSegment: "OPAQUE & PACKAGE",
      "Rooms Sold": "0",
      "Average ADR": "0",
    },
    {
      Date: "2025-06-01",
      MarketSegment: "QUALIFIED DISCOUNT",
      "Rooms Sold": "0",
      "Average ADR": "0",
    },
    {
      Date: "2025-06-01",
      MarketSegment: "CORPORATE NEGOTIATED",
      "Rooms Sold": "0",
      "Average ADR": "0",
    },
  ];

  const _RoomsSoldData = {
    labels: [
      "RETAIL",
      "OTA DISCOUNT",
      "UNMAPPED",
      "BRAND DISCOUNT",
      "GROUP",
      "OPAQUE & PACKAGE",
      "QUALIFIED DISCOUNT",
      "CORPORATE NEGOTIATED",
    ],
    datasets: [
      {
        label: "Room Sold",
        data: [0, 0, 0, 0, 0, 0, 0, 0],
        backgroundColor: [
          commonService.CreateColor("RETAIL").BGColor,
          commonService.CreateColor("OTA DISCOUNT").BGColor,
          commonService.CreateColor("UNMAPPED").BGColor,
          commonService.CreateColor("BRAND DISCOUNT").BGColor,
          commonService.CreateColor("GROUP").BGColor,
          commonService.CreateColor("OPAQUE & PACKAGE").BGColor,
          commonService.CreateColor("QUALIFIED DISCOUNT").BGColor,
          commonService.CreateColor("CORPORATE NEGOTIATED").BGColor,
        ],
        borderColor: "#fff",
        borderWidth: 1,
      },
    ],
  };
  const _AverageADRData = {
    labels: [
      "RETAIL",
      "OTA DISCOUNT",
      "UNMAPPED",
      "BRAND DISCOUNT",
      "GROUP",
      "OPAQUE & PACKAGE",
      "QUALIFIED DISCOUNT",
      "CORPORATE NEGOTIATED",
    ],
    datasets: [
      {
        label: "ADR",
        data: [0, 0, 0, 0, 0, 0, 0, 0],
        backgroundColor: [
          commonService.CreateColor("RETAIL").BGColor,
          commonService.CreateColor("OTA DISCOUNT").BGColor,
          commonService.CreateColor("UNMAPPED").BGColor,
          commonService.CreateColor("BRAND DISCOUNT").BGColor,
          commonService.CreateColor("GROUP").BGColor,
          commonService.CreateColor("OPAQUE & PACKAGE").BGColor,
          commonService.CreateColor("QUALIFIED DISCOUNT").BGColor,
          commonService.CreateColor("CORPORATE NEGOTIATED").BGColor,
        ],
        borderColor: "#fff",
        borderWidth: 1,
      },
    ],
  };

  const [MarketsegmentData, setMarketsegmentData] = useState([]);

  const [AverageADRData, setAverageADRData] = useState(_AverageADRData);
  const [RoomsSoldData, setRoomsSoldData] = useState(_RoomsSoldData);

  const [MARKETSEGMENT_chart_loader, setMARKETSEGMENT_chart_loader] =
    useState(false);
  const MARKETSEGMENT_chart = async () => {
    setMARKETSEGMENT_chart_loader(true);
    let customday = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.MONEY_CONTROL.MARKETSEGMENT_MIX_CHART,
        body: {
          propertyCode: para?.propertyCode,
        },
      },
      false
    );

    let customdayresponse = apiResponse(false, customday);

    if (customdayresponse?.isValidate) {
      setMarketsegmentData(customdayresponse?.data?.data);
      let labels = [];
      let backgroundColor = [];
      let _AverageADR = [];
      let _RoomsSold = [];
      for (let i = 0; i < customdayresponse?.data?.data.length; i++) {
        labels.push(customdayresponse?.data?.data[i]["MarketSegment"]);
        backgroundColor.push(
          commonService.CreateColor(
            customdayresponse?.data?.data[i]["MarketSegment"]
          ).BGColor
        );
        _AverageADR.push(
          parseInt(customdayresponse?.data?.data[i]["Average ADR"])
        );
        _RoomsSold.push(
          parseInt(customdayresponse?.data?.data[i]["Rooms Sold"])
        );
      }
      _RoomsSoldData.labels = labels;
      _RoomsSoldData.datasets[0].backgroundColor = backgroundColor;
      _RoomsSoldData.datasets[0].data = _RoomsSold;

      _AverageADRData.labels = labels;
      _AverageADRData.datasets[0].backgroundColor = backgroundColor;
      _AverageADRData.datasets[0].data = _AverageADR;

      setAverageADRData(_AverageADRData);
      setRoomsSoldData(_RoomsSoldData);
    } else {
      setMarketsegmentData([]);
    }
    setMARKETSEGMENT_chart_loader(false);
  };

  useEffect(() => {
    if (api === 0) {
      setMarketsegmentData(dummydata);
    } else {
      if (para?.propertyCode) {
        MARKETSEGMENT_chart();
      }
    }
  }, [para?.propertyCode]);

  commonService.setBackColorPerByTDValue(
    "#07a60a",
    "#07a60a",
    `#${tblids.id1} .perbackground-roomsold`,
    "left"
  );
  
  // Prev. 
  // commonService.setBackColorPerByTDValue(
  //   "#164389",
  //   "#164389",
  //   `#${tblids.id1} .perbackground-averageadr`
  // );
  // New.
  commonService.setBackColorPerByTDValue(
    "#add8e6",
    "#add8e6",
    `#${tblids.id1} .perbackground-averageadr`
  );

  const RoomsSoldOption = {
    responsive: true,

    plugins: {
      title: {
        display: true,
        text: "Room Sold",
        align: "center",
        position: "bottom",
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || "";
            const value = context.raw;
            return `${label}: ${value}`;
          },
        },
      },
    },
  };

  const AverageADROption = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "ADR",
        align: "center",
        position: "bottom",
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || "";
            const value = context.raw;
            return `${label}: ${propertyDetailFromRTK?.currency_term + value}`;
          },
        },
      },
    },
  };

  return (
    <div className="widget-container" style={{position: "relative", padding: "0 5px"}}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("ADRRoomSoldMarketSegmentMixAnalysis", "info", propertyCode)}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName: compName?.ADRRoomSoldMarketSegmentMixAnalysis,
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
        </div>
      )}
      <table>
        <tr>
        {MARKETSEGMENT_chart_loader ? (
          <Loader />
        ) : (
          <>
            {MarketsegmentData && MarketsegmentData.length > 0 && (
              <>
                <td style={{width: "25%"}}>
                  <div
                    style={{
                      width: "250px",
                      height: "250px",
                      margin: "0 auto",
                    }}
                  >
                    <Pie data={RoomsSoldData} options={RoomsSoldOption} />
                  </div>
                </td>
                <td style={{width: "50%"}}>
                  <div className="ViewPropertySetupTable">
                    <div className="stripped__table">
                      <Table id={tblids.id1} responsive>
                        <thead>
                          <tr>
                            <th> Market Segment</th>
                            <th
                              style={{ width: "33%" }}
                              className={"text-center"}
                            >
                              Rooms Sold
                            </th>
                            <th
                              style={{ width: "33%" }}
                              className={"text-center"}
                            >
                              ADR
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {MarketsegmentData.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td className={"d-flex"}>
                                  <div
                                    className={"me-2"}
                                    style={{
                                      background: commonService.CreateColor(
                                        item["MarketSegment"]
                                      ).BGColor,
                                      minWidth: "10px",
                                      minHeight: "10px",
                                      maxWidth: "10px",
                                      maxHeight: "10px",
                                    }}
                                  ></div>
                                  {item["MarketSegment"]}
                                </td>
                                <td
                                  className="text-center perbackground perbackground-roomsold border-right"
                                  value={item["Rooms Sold"]}
                                >
                                  {item["Rooms Sold"]}
                                </td>
                                <td
                                  className="text-center perbackground perbackground-averageadr border-right"
                                  value={item["Average ADR"]}
                                >
                                  {commonService.formateAmount(
                                    item["Average ADR"]
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </td>
                <td style={{width: "25%"}}>
                  <div
                    style={{
                      width: "250px",
                      height: "250px",
                      margin: "0 auto",
                    }}
                  >
                    <Pie data={AverageADRData} options={AverageADROption} />
                  </div>
                </td>
              </>
            )}
          </>
        )}
        </tr>
      </table>
      {api !== 0 && (
        <Comments
          widgetDetails={para}
          editorId={"ADRRoomSoldMarketSegmentMixAnalysis"}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default ADRRoomSoldMarketSegmentMixAnalysis;
